import { Reveal } from "@/lib/motion";
import { BOOK_REVIEW_MAILTO, CONTACT_EMAIL } from "@/lib/brand";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-bg-ink text-bg-base py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 paper-grain opacity-20 mix-blend-screen pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <Reveal>
          <div className="overline text-bg-base font-semibold">The next step</div>
        </Reveal>
        <Reveal delay={1}>
          <h2 className="mt-6 font-serif-display text-5xl sm:text-6xl md:text-7xl lg:text-[8.5rem] leading-[0.86] tracking-tightest text-bg-base">
            Reimagine<span className="brand-dot" />
            <br />
            <em className="font-light text-bg-base/95">your business.</em>
          </h2>
        </Reveal>
        <Reveal delay={2}>
          <p className="mt-8 max-w-2xl text-bg-base text-base md:text-lg leading-relaxed">
            Book a Business Review and we'll look at how your business runs today — and map a clearer way forward.
          </p>
        </Reveal>
        <Reveal delay={3}>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={BOOK_REVIEW_MAILTO}
              data-testid="final-cta-primary"
              className="inline-flex items-center justify-center gap-3 bg-brand-red hover:bg-brand-redHover text-white px-8 py-5 text-[13.5px] tracking-[0.06em] font-medium transition-colors"
            >
              Book a Review
              <span aria-hidden>→</span>
            </a>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="final-cta-secondary"
              className="inline-flex items-center justify-center gap-2 border border-bg-base/50 text-bg-base hover:bg-bg-base hover:text-ink px-8 py-5 text-[13.5px] tracking-[0.06em] font-medium transition-colors"
            >
              Email us directly
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
